import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import employeeHourTypeApi from '@infrastructure/employee-hour-type';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllEmployeeHourTypeAsync = createAsyncThunk('EmployeeHourType/GetAll', async (_, { rejectWithValue }) => {
    try {
        const response = await employeeHourTypeApi.getAllEmployeeHourType();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createEmployeeHourTypeAsync = createAsyncThunk('EmployeeHourType/Create', async (employeeHourType, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await employeeHourTypeApi.createEmployeeHourType(employeeHourType);
        dispatch(addSuccessNotification('Tijdwaarneming succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateEmployeeHourTypeAsync = createAsyncThunk('EmployeeHourType/Update', async (employeeHourType, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await employeeHourTypeApi.updateEmployeeHourType(employeeHourType);
        dispatch(addSuccessNotification('Tijdwaarneming succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmployeeHourTypeByIdAsync = createAsyncThunk('EmployeeHourType/GetById', async (employeeHourTypeById, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await employeeHourTypeApi.getEmployeeHourTypeById(employeeHourTypeById);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
